import BrandListContainer from './BrandListContainer';

export default BrandListContainer;
